// src/components/Dashboard/SimpleTable.js
import React from 'react';
import { Paper, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';

const DataTable = ({ data, title, bgColor, headers, onRowClick }) => (
    <Paper elevation={3} sx={{ p: 2, backgroundColor: bgColor, borderRadius: '10px' }}>
        <Typography variant="subtitle1" gutterBottom>{title}</Typography>
        <TableContainer>
            <Table size="small" sx={{ tableLayout: 'fixed' }}>
                <TableHead>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableCell
                                key={index}
                                align="left"
                                sx={{
                                    pl: 1,
                                    width: index === 0 ? '40%' : '60%',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {header}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow
                            key={row.vehicleNumber || index}                        >

                            {Object.keys(row)
                                .filter(key => key !== 'vehicleNumber' && key !== 'item')
                                .map((key, i) => (
                                    <TableCell
                                        key={i}
                                        align="left"
                                        sx={{
                                            pl: 1,
                                            width: '60%',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {row[key]}
                                    </TableCell>
                                ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
);

export default DataTable;